var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M373.4,0H138.6C62.2,0,0,62.2,0,138.6v234.8C0,449.8,62.2,512,138.6,512h234.8c76.4,0,138.6-62.2,138.6-138.6V138.6 C512,62.2,449.8,0,373.4,0z M256,396c-77.2,0-140-62.8-140-140s62.8-140,140-140s140,62.8,140,140S333.2,396,256,396z M399.3,149\tc-22.8,0-41.4-18.6-41.4-41.4s18.6-41.4,41.4-41.4s41.4,18.6,41.4,41.4S422.2,149,399.3,149z"}));
}

Instagram.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = Instagram;

Instagram.default = Instagram;
